import { Space, DatePicker, Select, Button, Input, Table, Popconfirm, Tooltip, Modal, Form, Switch, message, Image } from 'antd';
import { EditOutlined, FileExcelOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import moment from 'moment';
import WebLinks from '../../api/WebLinks';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import dayjs from 'dayjs';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, GetPriorityLevelIcons } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';

const { RangePicker } = DatePicker;
const { Search, TextArea } = Input;
const { Option } = Select
const currentDate = new Date()
var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

const SpendPerJobReport = (props) => {
  //Variable declaration
  const [dataSource, setDataSource] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [rangePickerValue, setRangePickerValue] = useState([]);
  const [count, setCount] = useState(0);
  const [filterPriorityLevel, setFilterPriorityLevel] = useState(null);
  const [searchJobTitleRef, setSearchJobTitleRef] = useState(null);
  const [searchLocationPostcode, setSearchLocationPostcode] = useState(null);
  const [priorityColorCode,setPriorityColorCode]=useState([]);
  const [priorityCheck,setPriorityCheck]=useState("f");
  const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [selectedSupplierIds,setSelectedsupplierIds]=useState([]);
  const [HiShowState,setHiShowState]=useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 200
  });
  const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;

  //Function on page load
  useEffect(() => {
    getBuyerPrioritylist();
    getAllowedSuppliers();
    let fromDate = props && props.dateSelectedValue ? props.dateSelectedValue[0] : dayjs(firstDay)?.format(constants.DateFormat2);
    let toDate = props && props.dateSelectedValue ? props.dateSelectedValue[1] : dayjs(lastDay)?.format(constants.DateFormat2);
    if (props && props.dateSelectedValue) {
      form.setFieldsValue({
        rangePicker: [dayjs(props.dateSelectedValue[0]), dayjs(props.dateSelectedValue[1])],
      })
    } else {
      form.setFieldsValue({
        rangePicker: [dayjs(fromDate),dayjs(toDate)],
      })
    }
    setRangePickerValue([
      fromDate,
      toDate
    ]);
    fetchSpendPerJobsList(fromDate, toDate, null);
  }, []);

  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      let temppriorityColorCode=[];
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
      response?.resultObj?.data.forEach(element => {
        let priorityObj={
          value:element.priorityLevel,
          colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
          customName:element.customName,
        }
        temppriorityColorCode.push(priorityObj);
        setPriorityColorCode(temppriorityColorCode);
      });
    } else {
			setPriorityColorCode([]);
      message.error(response?.resultObj?.message);
    }
  };

  // Table columns
  const yourJobsColumns = [
    {
      title: 'Active',
      key: 'active',
      dataIndex: 'active',
      align: 'center',
      // sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
      filters: [
        { text: 'Active', value: true },
        { text: 'Inactive', value: false },
      ],
      onFilter: (value, record) => record.active === value,
      render: (_, record) =>
        record.active === true ? (
          <Button
            icon={<CheckOutlined className="text-xl text-lime-500" />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ) : (
          <Button
            icon={<CloseOutlined className="text-xl text-lime-500" style={{ color: "red" }} />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ),
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      sorter: (a, b) => a.priority - b.priority,
      align: "center",
      render: (text,element) => <Space>
					{/* {GetPriorityLevelIcons(text)} */}
          <div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(element.priority):GetPriorityLevelColors(element.priority)}></div>
				</Space>
    },
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
      sorter: (a, b) => {
        const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
        const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);

        return referenceA - referenceB;
      },
    },
    {
      title: 'Job Title',
      dataIndex: 'title',
      key: 'jobTitle',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Location',
      dataIndex: 'place',
      key: 'place',
      sorter: (a, b) => a.place.localeCompare(b.place),
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      hidden: !HiShowState,
      sorter: (a, b) => a.state.localeCompare(b.state),
    },
    {
      title: 'Postcode',
      dataIndex: 'postcode',
      key: 'postcode',
      sorter: (a, b) => {
        if (a.postcode === '-') return -1; // '-' comes first
        if (b.postcode === '-') return 1; // '-' comes first
        return a.postcode.localeCompare(b.postcode);
      },
    },
    {
      title: 'Apps',
      dataIndex: 'applicationCount',
      key: 'applicationCount',
      sorter: (a, b) => a.applicationCount - b.applicationCount,
    },
    // {
    //   title: '/Day',
    //   dataIndex: 'applicationCount',
    //   key: 'applicationCount',
    //   render: (_, record) => {
    //     const daysValue = GetNoofDays(record.applicationCount, record.posted);
    //     const formattedValue = Number.isInteger(daysValue) ? daysValue.toFixed(0) : daysValue.toFixed(2);

    //     return (
    //       <div>
    //         {formattedValue}
    //       </div>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     const aValue = GetNoofDays(a.applicationCount, a.posted);
    //     const bValue = GetNoofDays(b.applicationCount, b.posted);

    //     return aValue - bValue; // You can adjust the comparison logic as needed
    //   },

    // },
    {
      title: 'Spend',
      dataIndex: 'spend',
      key: 'spend',
      sorter: (a, b) => a.spend - b.spend,
    },
    {
      title: 'CPA',
      dataIndex: 'cpa',
      key: 'cpa',
      sorter: (a, b) => a.cpa - b.cpa,
    },
    {
      title: 'Interviews',
      dataIndex: 'interview',
      key: 'interview',
      sorter: (a, b) => a.interview - b.interview,
    },
    {
      title: 'CPI',
      dataIndex: 'cpi',
      key: 'cpi',
      sorter: (a, b) => a.cpi - b.cpi,
    },
    {
      title: 'Offers',
      dataIndex: 'offer',
      key: 'offer',
      sorter: (a, b) => a.offer - b.offer,
    },
    {
      title: 'Hires',
      dataIndex: 'hired',
      key: 'hired',
      sorter: (a, b) => a.hired - b.hired,
    },
    {
      title: 'CPH',
      dataIndex: 'cph',
      key: 'cph',
      sorter: (a, b) => a.cph - b.cph,
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      // hidden: !HiShowCompanyName,
      sorter: (a, b) => a?.companyName?.localeCompare(b?.companyName),
    },
  ];
	const expandedTableColumns = [
		{
			title: 'Supplier',
			dataIndex: 'supplierName',
			key: 'supplierName',
			render: (_, record) => {
				return (
					<div className='mr-2'>
						{record.logoURL && record.logoURL !== "" ?
							<Image src={record.logoURL} preview={false} width={120} /> :
							<span>{record.supplierName}</span>
						}
					</div>
				)

			},
		},
    {
      title:<span className='opacity-0'>Reference</span>,
      dataIndex: 'reference',
      key: 'reference',
      sorter: (a, b) => {
        const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
        const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);
        return referenceA - referenceB;
      },
      showSorterTooltip: false, // hides tooltip
      className: 'faded-sort-icon',
    },
    {
      title: <span className='opacity-0'>Job Title</span>,
      dataIndex: 'title',
      key: 'jobTitle',
      sorter: (a, b) => a.title.localeCompare(b.title),
      className: 'faded-sort-icon',
    },
    {
      title: <span className='opacity-0'>Location</span>,
      dataIndex: 'place',
      key: 'place',
      sorter: (a, b) => a.place.localeCompare(b.place),
      className: 'faded-sort-icon',
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      hidden: !HiShowState,
      sorter: (a, b) => a.state.localeCompare(b.state),
    },
    {
      title: <span className='opacity-0'>Postcode</span>,
      dataIndex: 'postcode',
      key: 'postcode',
      sorter: (a, b) => {
        if (a.postcode === '-') return -1; // '-' comes first
        if (b.postcode === '-') return 1; // '-' comes first
        return a.postcode.localeCompare(b.postcode);
      },
      className: 'faded-sort-icon',
    },
    {
      title: 'Apps',
      dataIndex: 'applicationCount',
      key: 'applicationCount',
      sorter: (a, b) => a.applicationCount - b.applicationCount,
    },
    {
      title: 'Spend',
      dataIndex: 'spend',
      key: 'spend',
      sorter: (a, b) => a.spend - b.spend,
    },
    {
      title: 'CPA',
      dataIndex: 'cpa',
      key: 'cpa',
      sorter: (a, b) => a.cpa - b.cpa,
    },
    {
      title: 'Interviews',
      dataIndex: 'interview',
      key: 'interview',
      sorter: (a, b) => a.interview - b.interview,
    },
    {
      title: 'CPI',
      dataIndex: 'cpi',
      key: 'cpi',
      sorter: (a, b) => a.cpi - b.cpi,
    },
    {
      title: 'Offers',
      dataIndex: 'offer',
      key: 'offer',
      sorter: (a, b) => a.offer - b.offer,
    },
    {
      title: 'Hires',
      dataIndex: 'hired',
      key: 'hired',
      sorter: (a, b) => a.hired - b.hired,
    },
    {
      title: 'CPH',
      dataIndex: 'cph',
      key: 'cph',
      sorter: (a, b) => a.cph - b.cph,
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      //hidden: !HiShowCompanyName,
      sorter: (a, b) => a?.companyName?.localeCompare(b?.companyName),
    },
	];
	//Function on change of supplier selection
	const handleSupplierSelect=(selectedSuppliers)=>{
    onClear();
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedSuppliersFinal
			})
			setSelectedsupplierIds(selectedSuppliersFinal);
      fetchSpendPerJobsList(rangePickerValue[0], rangePickerValue[1], filterPriorityLevel,selectedSuppliersFinal);
		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
			setSelectedsupplierIds([]);
      fetchSpendPerJobsList(rangePickerValue[0], rangePickerValue[1], filterPriorityLevel,null);
		}
	}

  //Fetch the jobs upload history for the last 30 days 
  const fetchSpendPerJobsList = async (fromDate, toDate, priorityLevel = null,supplierId=null) => {
    setIsLoading(true);
    let url = WebLinks.GetApplicationSpendPerJob + buyerId+ "&fromDate=" + fromDate + "&toDate=" + toDate;
    if (priorityLevel && priorityLevel !== "-1") {
      url += "&priorityLevel=" + priorityLevel;
    }
    if(supplierId && supplierId.length>0){
      url += "&selectedSupplierId=" + supplierId;
    }
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setDataSource(response.resultObj.data);
      setFilteredDataSource(response.resultObj.data)
      setCount(response.resultObj.getCount);
      setHiShowState(response.resultObj?.hiShowState);
    } else {
      message.error(response.resultObj?.message);
    }
    setIsLoading(false);
  };

  const GetNoofDays = (apps, createdOn) => {
    if (apps === 0) {
      return 0;
    }
    // Check if `createdOn` is a valid date
    const creationDate = new Date(createdOn);
    if (isNaN(creationDate)) {
      return 0; // Handle invalid date gracefully
    }
    const currentDate = new Date();
    const difference = currentDate - creationDate;
    if (difference === 0) {
      return apps; // Avoid division by zero
    }
    const daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24)) + 1;
    // Ensure `apps` is a valid number before division
    if (isNaN(apps)) {
      return 0; // Handle invalid `apps` value gracefully
    }
    return apps / daysDifference;
  };

  //Function to change the Active button to cross or tick.
  const changeActive = async (rowKey, previousValue) => {
    let tbldata = [...dataSource];
    let index = tbldata.findIndex((row) => row.id === rowKey);
    if (index > -1) {
      if (tbldata[index].active === true) {
        tbldata[index].active = false;
      } else {
        tbldata[index].active = true;
      }
      setFilteredDataSource(tbldata);
    }
    //Api call to update in DB
    let activePayload = null;
    activePayload = {
      jobId: rowKey,
      active: !previousValue,
    }
    const activeResponse = await APIUtils.apiCall('PUT', WebLinks.PutActiveJob, JSON.stringify(activePayload));
    if (activeResponse.isCatch) {
      message.error(message.resultObj.message);
    }
  };

	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliers);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  const downloadFile = (isSupplier) => {
    setIsLoading(true)
    //api/Report/SpendPerJob?buyerId=555&fromDate=Dec-2023&toDate=Dec-2023
    //const buyerId = buyerId
    let url ;
    if(isSupplier==="t"){
     url = WebLinks.DownloadApplicationSpendPerJobBySupplier + buyerId + '&fromDate=' + rangePickerValue[0] + '&toDate=' + rangePickerValue[1];
    }else{
     url = WebLinks.DownloadApplicationSpendPerJob + buyerId + '&fromDate=' + rangePickerValue[0] + '&toDate=' + rangePickerValue[1];
    }
    if (filterPriorityLevel && filterPriorityLevel !== "-1") {
      url += "&priorityLevel=" + filterPriorityLevel;
    }
    if(selectedSupplierIds && selectedSupplierIds.length>0){
      url += "&selectedSupplierId=" + selectedSupplierIds;
    }
    const accessToken = Cookies.get(constants.COOKIE_TOKEN)
    fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      }
    })
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "SpendPerJobReport.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoading(false)
        message.success('File downloaded successfully');
      })
      .catch(error => {
        setIsLoading(false)
        message.error('Error downloading file');
      });
  }

  //Function runs when range picker value is changed
  const RangePickerChanged = (_, dateString) => {
    props.changeDate(dateString);
    setRangePickerValue(dateString);
    fetchSpendPerJobsList(dateString[0], dateString[1], filterPriorityLevel,selectedSupplierIds);
  };

  // Function to handle search
  const handleSearch = (value, isJobTitleRef) => {
    setIsLoading(true);
    if (value) {
      setFilteredDataSource([]);
      const searchTermLower = value.toLowerCase().trim();
      const keyToSearch = isJobTitleRef ? ['title', 'reference'] : ['place', 'postcode'];

      const results = dataSource.filter((item) =>
        keyToSearch.some((key) => item[key].toString().toLowerCase().includes(searchTermLower))
      );
      setFilteredDataSource(results);
      setCount(results.length);
      setIsLoading(false);
    }
    else {
      setFilteredDataSource(dataSource)
      setCount(dataSource.length)
      setIsLoading(false);
    }
  };

  const onClear = () => {
    setFilteredDataSource(dataSource)
    setSearchJobTitleRef(null)
    setSearchLocationPostcode(null)
  }

  //Function on priority filter change
  const filterPriority = (value) => {
    onClear();
    if(value!==-1){
    setFilterPriorityLevel(value)
    }else{
      setFilterPriorityLevel(null);
    }
    fetchSpendPerJobsList(rangePickerValue[0], rangePickerValue[1], value?.toString(),selectedSupplierIds);
  }

	//Funcion to render inner table
	const getInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				pagination={false}
			/>
		)
	}

const startPage = (pagination.current - 1) * pagination.pageSize + 1;
const endPage = Math.min(startPage + pagination.pageSize - 1, count);

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Space wrap>
          <Form form={form} className='!w-full flex flex-wrap justify-between items-center gap-3 mb-3'>
            <Form.Item name="rangePicker" className='mb-0'>
              <RangePicker className="w-[65vw] md:w-60"  placeholder={["From", "To"]} onChange={RangePickerChanged}  />
            </Form.Item>
          <label className='ml-2 mr-2'>Filter by Supplier</label>
					<Form.Item name="supplierList" className='mb-0'>
						<Select
							loading={suplierListLoader}
							className='!w-60'
							// value={selectedSupplier || []}
							placeholder={constants.supplierName}
							mode='multiple'
							allowClear
							defaultValue={"showall"}
							showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleSupplierSelect(e)}
							>
								<Option key='showall' value='showall'>Show all</Option>
									{allowedSupplierList?.map((supplier) => (
										<Option key={supplier.supplierId}
												value={supplier.supplierId}
										>
										{supplier.name}</Option>
							))}
						</Select>
					</Form.Item>
          </Form>
        </Space>
        <Space wrap>
          <Search
            placeholder="Job Title / Ref"
            allowClear={false}
            onSearch={(e) => handleSearch(e, true)}
            enterButton
            value={searchJobTitleRef}
            onChange={(e) => setSearchJobTitleRef(e.target.value)}
            className="w-full md:w-60"
          />
          <Search
            placeholder="Location / Postcode"
            allowClear={false}
            onSearch={(e) => handleSearch(e, false)}
            enterButton
            value={searchLocationPostcode}
            onChange={(e) => setSearchLocationPostcode(e.target.value)}
            className="w-full md:w-60"
          />
          <Button onClick={() => onClear()}>Clear Search</Button>
          <Select
           onChange={filterPriority}
            defaultValue={"-1"}
            placeholder="Please select"
            className="w-[65vw] md:w-52"
          >
            <Option value="-1">
              <Space>
                Priority Filter - Show All
              </Space>
            </Option>
            {priorityColorCode?.map((item=>{
                  return(
                <Option value={item.value}>
                    <Space>
                      <div className={item.colorValue}></div>
                      {item.customName}
                    </Space>             
                </Option>
                  )
                }))}
          </Select>
          <Tooltip placement='right' title="Download as Excel">
            <Button onClick={() => downloadFile("t")} className="bg-green-800 text-white hover:!text-white hover:!border-green-500" icon={<FileExcelOutlined />}> {constants.DownloadBySupplier}</Button>
          </Tooltip>
          <Tooltip placement='right' title="Download as Excel">
            <Button onClick={() => downloadFile("f")} className="bg-green-800 text-white hover:!text-white hover:!border-green-500" icon={<FileExcelOutlined />}> {constants.Download}</Button>
          </Tooltip>
        </Space>
      </div>
      <div className="overflow-x-auto">
        <Table
          loading={isLoading}
          size='small'
          pagination={{
            current: pagination.current,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
            onChange: (page, pageSize) => {
              setPagination({
                current: page,
                pageSize: pageSize
              });
            }
          }}
          expandable={{
            expandedRowRender: (record) => (<div>
              {getInnerTable(record.spendPerJobsDetails)}
            </div>)
          }}
           rowKey="rowNum"
          columns={yourJobsColumns}
          dataSource={filteredDataSource}
          onChange={(pagination, filters, sorter, extra)=>setCount(extra?.currentDataSource?.length||0)}
          footer={() => `Showing ${count===0?0:startPage} to ${endPage} of ${count} entries`}
        />
      </div>
    </div>
  );
};

export default SpendPerJobReport;